<template>
  <success-page-layout
      web-to-mobile-flag="webPremiumPurchased"
      store-badges-button-code="body-20241205-success-page-giftcard-redeemed"
  >
    <template v-slot:content>
      <b-headline type="h1" typography="h2" class="mb-4">
        {{ $t("headline") }}
      </b-headline>
      <p v-html="$t('copy')" />
    </template>

    <template v-slot:image>
      <purchase-image />
    </template>
  </success-page-layout>
</template>

<script>
import BHeadline from "@/component-library/b-headline"
import SuccessPageLayout from "@/pages/success-page/components/success-page-layout"
import PurchaseImage from "@/pages/success-page/components/purchase/image.vue";

export default {
  name: "Go1AccountConnected",
  components: {
    PurchaseImage,
    BHeadline,
    SuccessPageLayout
  },
  i18n: {
    messages: {
      en: {
        headline: "Congrats! You redeemed your gift card!",
        copy: "Blinkist is best when you use it on the app. Download it, and get powerful ideas when you need them: anytime, anywhere!"
      },
      de: {
        headline: "Herzlichen Glückwunsch! Deine Geschenkkarte wurde eingelöst!",
        copy: "Blinkist ist am Besten, wenn du es in der App verwendest. Lade sie herunter und hole dir starke Ideen, wenn du sie brauchst: jederzeit und überall!"
      }
    }
  }
}
</script>
